/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Header,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderName,
  HeaderNavigation,
  SideNavItems,
  SideNav,
  SideNavMenuItem,
  Button,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'carbon-components-react';
import {
  entitiesLabels,
} from '../../helpers/Constants';
import Notification20 from '@carbon/icons-react/lib/notification/20';
import Menu20 from '@carbon/icons-react/lib/menu/20';
import { authProvider } from '../../auth/authProvider';
import { Notification } from './Notification';
import { BoxProfile } from './BoxProfile';
import { AppContext } from '../../helpers/context/AppContext';
import { IsInRole } from '../../helpers/authorization/Policies';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import { Online, Offline } from './OnLineOffLine';
import CacheStorage from '../../helpers/api/CacheStorage';
import { showNotification } from '../../helpers/notification/BaseNotification';
import AuditRepository from '../../helpers/api/AuditRepository';
import IncidentRepository from '../../helpers/api/IncidentRepository';
import MeRepository from '../../helpers/api/MeRepository';
import ReportRepository from '../../helpers/api/ReportRepository';
import HocCardRepository from '../../helpers/api/HocCardRepository';
import TrainingRepository from '../../helpers/api/TrainingRepository';
import InspectionRepository from '../../helpers/api/InspectionRepository';
import DrillRepository from '../../helpers/api/DrillRepository';

var isDeleted = false;

export class Head extends Component {
  constructor(props) {
    super(props);
    this.showProfile = this.showProfile.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.hiddenBox = this.hiddenBox.bind(this);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.modalFetchData = this.modalFetchData.bind(this);
    this.handleConfirmFetchData = this.handleConfirmFetchData.bind(this);
    this.auditRepository = new AuditRepository();
    this.state = {
      collapsed: true,
      userAccount: 'Not Authorized',
      isSideNavigationExpanded: false,
      isOpenNotification: false,
      isOpenProfile: false,
      synching: false,
      offlineQueue: 0,
      modalFetchDataVisible: false,
      isDeleted: false
      };
    this.isDeleted = this.isDeleted.bind(this);
    this.onClickSideNavExpand = this.onClickSideNavExpand.bind(this);
    this.onGoOnline = this.onGoOnline.bind(this);
    this.onMessageReceived = this.onMessageReceived.bind(this);
    this.getUserRole = this.getUserRole.bind(this);
    this.cacheStorage = new CacheStorage();
  }

  hiddenBox() {
    this.setState((oldState) => ({ isOpenProfile: !oldState.isOpenProfile }));
  }

    async isDeleted() {
        isDeleted = true;

    }


    showNotification() {
        if (!isDeleted) {
            this.state.isOpenProfile
                ? this.setState((oldState) => ({
                    isOpenProfile: !oldState.isOpenProfile,
                    isOpenNotification: !oldState.isOpenNotification,
                }))
                : this.setState((oldState) => ({ isOpenNotification: !oldState.isOpenNotification }));
        }
        isDeleted = false;
    } 

  showProfile() {
    this.state.isOpenNotification
      ? this.setState((oldState) => ({
          isOpenProfile: !oldState.isOpenProfile,
          isOpenNotification: !oldState.isOpenNotification,
        }))
      : this.setState((oldState) => ({ isOpenProfile: !oldState.isOpenProfile }));
  }

  getUserRole() {
    if (this.context.user.roles.includes('Administrator')) {
      return 'Administrator';
    } 
    else if (this.context.user.roles.includes('Compiler')) {
      return 'Compiler';
    }
    else if (this.context.user.roles.includes('Data Approver')) {
      return 'Data Approver';
    }
    else if (this.context.user.roles.includes('Division Manager')) {
      return 'Consolidator';
    } 
    else {return 'External'}
  }

  onGoOnline(online) {
    if (online) this.cacheStorage.flushQueue();
  }

    onMessageReceived = (message) => {
        console.log(`Header.onMessageReceived: message:`, message);
        if (message.infoMsg)
            showNotification.info("Info", message.infoMsg);
        if (message.warnMsg)
            showNotification.warning("Warning", message.warnMsg);
        if (message.errMsg)
            showNotification.error("Error", message.errMsg);
        if (message.sucMsg)
            showNotification.success("Success", message.sucMsg);

        if (message.queueLength !== null) {
          this.setState({ offlineQueue: message.queueLength });
        }

        if (message.synching !== null) {
          this.setState({ synching: message.synching });
          switch (message.synching) {
              case true:
                  showNotification.info(`${entitiesLabels.SYNC}`, 'Operation started');
                  console.log('Header.onMessageReceived: Synch operation started');
              break;
            case false:
              if (!message.error) {
                  showNotification.success(`${entitiesLabels.SYNC}`, 'Operation ended successfully');
                  console.log('Header.onMessageReceived: Synch operation ended successfully');
              } else if (message.error) {
                  showNotification.error(`${entitiesLabels.SYNC}`, `Operation ended with ${message.queueLength} errors and ${message.minRetriesLeft} retries left. Queue size: ${message.totalQueueSizeKB} KB`);
                  console.error(`Header.onMessageReceived: Synching operation ended with ${message.queueLength} errors and ${message.minRetriesLeft} retries left. Queue size: ${message.totalQueueSizeKB} KB`);
              }
              break;
            default:
              break;
          }
        }
    };

    modalFetchData() {
        console.log(`Header.modalFetchData:`);
        this.setState((oldState) => ({
            modalFetchDataVisible: !oldState.modalFetchDataVisible,
        }));
    }

    async handleConfirmFetchData() {
        console.log(`Header.handleConfirmFetchData:`);
        this.setState((oldState) => ({
            synching: true,
            modalFetchDataVisible: !oldState.modalFetchDataVisible,
        }));
        showNotification.success(`${entitiesLabels.SUCCESS}`,'Synch operation started');
        await MeRepository.preFetch();
        if (this.context.user.modules.includes('Audit')) {
          await this.auditRepository.fetchAudit();
        }
        if (this.context.user.modules.includes('Incident')) {
          await IncidentRepository.fetchIncident();
        }
        if (this.context.user.modules.includes('Report')) {
          await ReportRepository.preFetch();
        }
        if (this.context.user.modules.includes('Hoc Card')) {
          await HocCardRepository.preFetch();
        }
        if (this.context.user.modules.includes('Training')) {
          await TrainingRepository.fetchTraining();
        }
        if (this.context.user.modules.includes('Inspection')) {
          await InspectionRepository.preFetch();
        }
        if (this.context.user.modules.includes('Emergency Drill')) {
          await DrillRepository.preFetch();
        }
        this.setState((oldState) => ({
          synching: false,
        }));
        showNotification.success(`${entitiesLabels.SUCCESS}`,'Synch operation ended successfully');
    }

    toggleNavbar() {
        console.log(`Header.toggleNavbar:`);
        this.setState((oldState) => ({
            collapsed: !oldState.collapsed,
        }));
    }

    componentDidMount() {
        console.log(`Header.componentDidMount:`);
        this.setState({ userAccount: authProvider.account.name });
    }

    onClickSideNavExpand() {
        console.log(`Header.componentDidMount:`);
        this.setState((oldState) => ({
            isSideNavigationExpanded: !oldState.isSideNavigationExpanded,
        }));
    }

    logout = () => {
        authProvider.logout();
    };

  renderFetchModal = () =>
    this.state.modalFetchDataVisible && (
      <ComposedModal
        className="light-modal"
        open
        danger="false"
        onClose={() => {
          this.modalFetchData();
        }}
      >
        <ModalHeader
          className="margin-modal"
          title="Entities Data Pre Load"
          iconDescription="Close"
          buttonOnClick={this.modalFetchData}
        />
        <ModalBody className="margin-modal">
          <div className="bx--grid--full-width">
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">Press confirm to start loading entities data </h5>
                <br />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="button--max-width" kind="secondary" onClick={this.modalFetchData}>
            Cancel
          </Button>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={() => this.handleConfirmFetchData()}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ComposedModal>
    );

  render() {
    console.log(`Header.render: navigator.onLine: ${navigator.onLine}`);
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            {this.renderFetchModal(user)}
            <Header aria-label="Prometheus" className="header header-img">
              <HeaderGlobalAction
                className="menu"
                aria-label="Menu"
                onClick={this.onClickSideNavExpand}
                isActive={this.state.isSideNavigationExpanded}
              >
                <Menu20 />
              </HeaderGlobalAction>

              <HeaderName href="/" prefix="" className="bx--home-header">
                <img className="logo" src="/images/saipem-insights.png" alt="Saipem inSights" />
              </HeaderName>

              <HeaderNavigation className="headerNavigation" aria-label="">
                <Link to="/dailytasks">Daily Tasks</Link>
                {IsInRole(user) ? <Link to="/modules">Modules</Link> : <li />}
                <Link to="/support">Support</Link>
                {IsInRole(user, 'Administrator') ? (
                  <Link to="/backoffice">BackOffice</Link>
                ) : (
                  <li />
                )}
              </HeaderNavigation>

              <HeaderGlobalBar>
                <div className="navbar-action">
                  <HeaderName prefix="" onClick={this.showProfile}>
                    {this.state.userAccount + " - " +this.getUserRole()}
                  </HeaderName>
                  <BoxProfile
                    isUser={IsInRole(user)}
                    userAccount={this.state.userAccount}
                    isOpen={this.state.isOpenProfile}
                    hiddenBox={this.hiddenBox}
                  />
                </div>
                <HeaderGlobalAction aria-label="Notifications" onClick={this.showNotification}>
                  <Notification20 />
                                <Notification isOpen={this.state.isOpenNotification} isDeleted={this.isDeleted} />
                </HeaderGlobalAction>
                <Online onChange={this.onGoOnline} onMessageReceived={this.onMessageReceived}>
                  <HeaderGlobalAction
                    aria-label="Status"
                    onClick={this.modalFetchData}
                    disabled={this.state.synching}
                  >
                    <div className={this.state.synching ? 'pulsating-circle' : 'online-circle'} />
                    <div className="notification-box notification-off">
                      {this.state.offlineQueue != null && this.state.offlineQueue > 0 ? (
                        <div className="notification-dot">
                          <span className="notification-span">
                            {this.state.offlineQueue < 99 ? this.state.offlineQueue : '+99'}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </HeaderGlobalAction>
                </Online>
                <Offline>
                  <HeaderGlobalAction aria-label="Status" onClick={this.modalFetchData} disabled>
                    <div className="offline-circle" />
                                    <div className="notification-box">
                      {this.state.offlineQueue != null && this.state.offlineQueue > 0 ? (
                                            <div className="notification-dot notification-off notification-dot-lager">
                          <span className="notification-span notification-span-larger">
                            {this.state.offlineQueue < 99 ? this.state.offlineQueue : '+99'}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </HeaderGlobalAction>
                </Offline>
                {process.env.REACT_APP_ENVNAME !== 'PROD' ? (
                  <HeaderGlobalAction aria-label="ENV">
                    <StatusTag value={process.env.REACT_APP_ENVNAME} />
                  </HeaderGlobalAction>
                ) : null}
              </HeaderGlobalBar>

              {this.state.isSideNavigationExpanded ? (
                <SideNav
                  aria-label="Side navigation"
                  expanded={this.state.isSideNavigationExpanded}
                  defaultExpanded={false}
                >
                  <SideNavItems>
                    <SideNavMenuItem onClick={this.onClickSideNavExpand} isSideNavExpanded>
                      <Link to="/dailytasks">Daily Tasks</Link>
                    </SideNavMenuItem>
                    {IsInRole(user) ? (
                      <SideNavMenuItem onClick={this.onClickSideNavExpand} isSideNavExpanded>
                        <Link to="/modules">Modules</Link>
                      </SideNavMenuItem>
                    ) : (
                      ''
                    )}
                    <SideNavMenuItem onClick={this.onClickSideNavExpand} isSideNavExpanded>
                      <Link to="/support">Support</Link>
                    </SideNavMenuItem>
                    {IsInRole(user, 'Administrator') ? (
                      <SideNavMenuItem onClick={this.onClickSideNavExpand} isSideNavExpanded>
                        <Link to="/backoffice">BackOffice</Link>
                      </SideNavMenuItem>
                    ) : (
                      ''
                    )}
                  </SideNavItems>
                </SideNav>
              ) : null}
            </Header>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
Head.contextType = AppContext;
